module.exports = __webpack_public_path__ + "img/CardImage7.b96d75f0.png";